import { Text } from '@chakra-ui/react';

/**
 * URL du logo Alma orange.
 *
 * Le fichier est servi depuis la racine du site (BASE_URL vaut "/" faute de
 * `base` dans vite.config), convention déjà en place pour logoalma.svg et
 * almapayment.svg. Vérifié présent sur les 10 domaines clubs le 04/09/2026.
 */
const ALMA_LOGO_SRC = `${import.meta.env.BASE_URL}logoalmaorange.svg`;

interface AlmaMentionProps {
  /** Texte affiché avant le logo. Vide ⇒ le composant ne rend rien. */
  text: string;
  /**
   * `card` : mention en bas de carte, logo sur sa propre ligne sous le texte.
   * `footer` : phrase centrée sous une grille, logo inline en fin de phrase.
   */
  variant: 'card' | 'footer';
  /** Couleur du texte, pilotée par la carte (fond clair, sombre ou image). */
  color?: string;
  /** Taille du texte, différente entre une carte pack et un top block. */
  fontSize?: string;
}

/**
 * Mention « Payer avec » + logo Alma (DCC2 : jamais « sans frais » ni
 * « en plusieurs fois », qui imposent les mentions légales du crédit).
 *
 * Centralise le rendu utilisé par PackCard, TopFeatureCard (ses deux modes) et
 * le pied de grille : le logo était auparavant absent des cartes, et la phrase
 * du pied de grille était codée en dur à un seul endroit.
 */
export function AlmaMention({ text, variant, color, fontSize }: AlmaMentionProps) {
  if (!text) {
    return null;
  }

  const isFooter = variant === 'footer';

  return (
    <Text
      className={isFooter ? 'serviceAlmaFooter' : 'serviceAlmaText'}
      fontSize={fontSize ?? (isFooter ? '14px' : '12px')}
      color={color ?? (isFooter ? '#6a6a6a' : undefined)}
      textAlign={isFooter ? 'center' : undefined}
      lineHeight="1.4"
      mt={isFooter ? 5 : undefined}
    >
      {text}
      {isFooter ? ' ' : <br />}
      <img
        src={ALMA_LOGO_SRC}
        alt="Alma"
        className="serviceAlmaLogo"
        style={
          isFooter
            ? { height: '14px', width: 'auto', display: 'inline', position: 'relative', top: '1px' }
            : { height: '14px', width: 'auto', display: 'inline-block', marginTop: '2px' }
        }
      />
    </Text>
  );
}
